import React from 'react';

const cardBase = 'rounded-xl p-5 border';
const cardAccent = {
  gold: 'bg-gradient-to-br from-[#1a1230] to-[#0a0820] border-gold/50 shadow-[0_0_18px_rgba(212,175,55,0.15)]',
  navy: 'bg-[#0a0820]/70 border-gold/25',
  danger: 'bg-red-900/20 border-red-500/40',
  success: 'bg-emerald-900/15 border-emerald-500/30',
};

/**
 * MetricsCards — top KPI row for Growth OS dashboard.
 *
 * Props:
 *   today?: DailyMetrics (may be null)
 *   yesterday?: DailyMetrics (may be null)
 */
export default function MetricsCards({ today, yesterday }) {
  const t = today || {};
  const y = yesterday || {};
  const cards = [
    {
      key: 'revenue',
      label: 'आज की Revenue',
      value: `₹${Number(t.revenue_inr || 0).toLocaleString('en-IN')}`,
      sub: `कल: ₹${Number(y.revenue_inr || 0).toLocaleString('en-IN')}`,
      accent: t.revenue_inr > 0 ? 'success' : 'navy',
    },
    {
      key: 'orders',
      label: 'Orders',
      value: `${t.orders_count || 0}`,
      sub: `Poocho ${t.poocho_orders || 0} · Booking ${t.booking_orders || 0}`,
      accent: 'gold',
    },
    {
      key: 'visitors',
      label: 'Unique Visitors',
      value: `${t.unique_visitors || '—'}`,
      sub: t.ga4 && Object.keys(t.ga4).length ? 'GA4 connected' : 'GA4 pending',
      accent: 'navy',
    },
    {
      key: 'abandoned',
      label: 'Abandoned Carts',
      value: `${t.abandoned_carts || 0}`,
      sub: `₹${Number(t.abandoned_value_inr || 0).toLocaleString('en-IN')} lost`,
      accent: (t.abandoned_carts || 0) > 0 ? 'danger' : 'navy',
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((c) => (
        <div
          key={c.key}
          data-testid={`growth-os-metric-${c.key}`}
          className={`${cardBase} ${cardAccent[c.accent]}`}
        >
          <div className="text-[10px] uppercase tracking-widest text-gold/70 font-semibold mb-2">
            {c.label}
          </div>
          <div className="font-heading text-3xl md:text-4xl text-text-main leading-none mb-1.5">
            {c.value}
          </div>
          <div className="text-xs text-text-muted">{c.sub}</div>
        </div>
      ))}
    </div>
  );
}
